import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../context/AuthContext';

const SignOut = () => {
  const navigate = useNavigate();
  const { checkSession } = useAuth();

  useEffect(() => {
    const signOutUser = async () => {
      try {
        await axios.post('/session-api/signout');
        await checkSession(); // Update the session state
        navigate('/');
      } catch (error) {
        console.error('Error signing out:', error);
        navigate('/');
      }
    };

    signOutUser();
  }, [navigate, checkSession]);

  return (
    <div>
      <Helmet>
        <title>Sign Out - {process.env.REACT_APP_SITE_NAME}</title>
      </Helmet>
      <h1>Signing Out...</h1>
    </div>
  );
};

export default SignOut;
